import Layout from '@/components/layout';
import ComparePlan from '@/pages/Pricing/components/ComparePlan';
import { BlockStack, Button } from '@shopify/polaris';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PricingFAQs from './components/PricingFAQs.tsx';
import { PricingStyled } from './styled';
import { config } from '@/config';

interface PricingProps {}

const Pricing: React.FC<PricingProps> = () => {
  const { t } = useTranslation('pricing');

  return (
    <Layout title={t('pricing')}>
      <PricingStyled id="pricing-page">
        <BlockStack gap="500">
          <div className="content-center">
            <Button
              onClick={() =>
                window.open(`https://www.wix.com/apps/upgrade/${process.env.REACT_APP_ID}?appInstanceId=${config.shop}`, '_blank')
              }
              variant="primary"
            >
              View all plans
            </Button>
          </div>

          <ComparePlan />

          <PricingFAQs />
        </BlockStack>
      </PricingStyled>
    </Layout>
  );
};

export default Pricing;
